/**
 * External dependencies
 */
import { View } from 'react-native';

// MediaReplaceFlow component is not yet implemented in the native version.
// For testing purposes, we are using an empty View component with a testID prop.
const MediaReplaceFlow = () => {
	return <View testID="media-replace-flow" />;
};

export default MediaReplaceFlow;
